module.exports = __webpack_public_path__ + "fonts/NeutraTextBold.eb0d8608.otf";